var bindEvent = (function() {
    if(document.addEventListener) {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false);
            }
        };
    } else {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler);
            }
        };
    }
})();

var unbindEvent = (function() {
    if(document.removeEventListener) {
        return function(element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false);
            }
        };
    } else {
        return function(element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler);
            }
        };
    }
})();

var bindOnce = function(el, event, fn) {
    var listener = function() {
        if (fn) {
            fn.apply(this, arguments);
        }
        unbindEvent(el, event, listener);
    };
    bindEvent(el, event, listener);
};

module.exports = {
    on: bindEvent,
    off: unbindEvent,
    once: bindOnce
};


// WEBPACK FOOTER //
// ./src/components/input-number/src/deps/event.js